<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Wybór koloru</p>
			<button
				type="button"
				class="delete"
				aria-label="close"
				@click="$parent.$emit('close')"
			></button>
		</header>
		<section class="modal-card-body">
			<div class="colors">
				<!-- <a :class="[ 'color', { selected: color.hex === selected.hex } ]" v-for="color in colors" :key="color.name" @click.prevent="selected = color"> -->
				<a
					:class="['color', { selected: color.hex === selected.hex }]"
					v-for="color in colors"
					:key="color.name"
					@click.prevent="select(color)"
				>
					<span class="color__preview" :style="getTagStyle(color.hex)"></span>
					<span class="color__name">{{ color.name }}</span>
				</a>
			</div>
			<hr />
			<p>
				Wybrany kolor: <b>{{ selected.name }}</b>
			</p>
		</section>
		<!-- <footer class="modal-card-foot">
      <button type="button" class="button is-success" @click.prevent="$parent.$emit('select', selected)">Wybierz</button>
      <button class="button is-white" type="button" @click="$parent.$emit('close')">Zamknij</button>
    </footer> -->
	</div>
</template>

<script>
import { ROUTE_COLORS } from '@/config/routeColors'

export default {
	name: 'ColorPicker',
	props: {
		preselected: {
			required: false,
			type: Object
		}
	},
	data() {
		return {
			selected: null,
			colors: ROUTE_COLORS.map(color => ({ name: color.label, hex: color.value }))
		}
	},
	methods: {
		getTagStyle(color) {
			return `background-color: ${color};`
		},
		select(color) {
			this.$emit('select', color)
			this.$parent.$emit('close')
		}
	},
	created() {
		this.selected = this.preselected ? this.preselected : this.colors[this.colors.length - 1]
	}
}
</script>

<style lang="scss" scoped>
.modal-card {
	.colors {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
	}
	.color {
		display: flex;
		flex: 1 0 calc(100% / 6 - 20px);
		flex-direction: column;
		text-align: center;
		margin: 10px;
		border: 1px solid #ccc;
		border-radius: 3px;
		transition: 0.1s;
		height: 85px;
		&:hover {
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
			transform: scale(1.05);
		}
		&.selected {
			border: 1px solid red;
			background-color: rgba(255, 0, 0, 0.05);
		}
		&:last-child {
			margin-right: 100%;
		}
		&__preview {
			height: 50px;
			display: block;
			margin: 5px 5px 0;
		}
		&__name {
			font-size: 14px;
			padding: 5px 10px;
			color: #000;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.mdi {
		font-size: 40px;
	}
}
</style>
